module.exports = __webpack_public_path__ + "img/dch-logo.a2a4066d.jpg";